<app-centre-small-opener>
  <h2 mat-dialog-title dialogTitle class="mar-b-5 pd-t-5px">Notes / Attachment</h2>
    <div contentContainer class="notesAttachmemnts" [ngStyle]="{'margin-bottom':'10px'}" >
      
    <mat-accordion multi>
  <mat-expansion-panel (opened)="panelOpenState = true"
  (closed)="panelOpenState = false">
    <mat-expansion-panel-header>
      <mat-panel-title>
      
          View Attachments
      </mat-panel-title>
   
    </mat-expansion-panel-header>
    <div class="monPDf">
      <div >
        <div class="">
            <table mat-table [dataSource]="dataSource">
          
              <!-- Position Column -->
              <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef [ngStyle]="{'width':'10%'}"  [ngStyle]="{'display':'none'}"> No. </th>
                <td mat-cell *matCellDef="let element"  [ngStyle]="{'display':'none'}"> {{element.position}} </td>
              </ng-container>
          
              <!-- Name Column -->
              <ng-container matColumnDef="attachReview">
                <th mat-header-cell *matHeaderCellDef  class="tbl_atta"> Attachments to be reviewed before the meeting </th>
                <td mat-cell *matCellDef="let element"> {{element.attachReview}} </td>
              </ng-container>
          
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          
            <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                           showFirstLastButtons 
                           aria-label="Select page of periodic elements">
            </mat-paginator> -->
        </div>
          
    </div>
    <div >
        <div class="">
            <table mat-table [dataSource]="dataTaskSource">
          
              <!-- Position Column -->
              <ng-container matColumnDef="position" >
                <th mat-header-cell *matHeaderCellDef [ngStyle]="{'width':'10%'}" [ngStyle]="{'display':'none'}"> No. </th>
                <td mat-cell *matCellDef="let element" [ngStyle]="{'display':'none'}"> {{element.position}} </td>
              </ng-container>
          
              <!-- Name Column -->
              <ng-container matColumnDef="tskReview">
                <th mat-header-cell *matHeaderCellDef class="tbl_atta">Task to be completed before the meeting</th>
                <td mat-cell *matCellDef="let element"> {{element.linkReview}} </td>
              </ng-container>
          
              <tr mat-header-row *matHeaderRowDef="displayedTaskColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedTaskColumns;"></tr>
            </table>
<!--                           
            <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                           showFirstLastButtons 
                           aria-label="Select page of periodic elements">
            </mat-paginator> -->
        </div>
          
    </div>
  </div>
  </mat-expansion-panel>
  <mat-expansion-panel (opened)="panelOpenStateNotes = true"
                       (closed)="panelOpenStateNotes = false">
    <mat-expansion-panel-header>
        <mat-panel-title>
         
            View Notes
          </mat-panel-title>
     
    </mat-expansion-panel-header>
    <div [ngStyle]="{'margin-left':'20px', 'margin-top':'5px', 'margin-bottom':'5px'}">
     
  </div>
  </mat-expansion-panel>
  </mat-accordion> 
    
    </div>
  
    <button mat-raised-button actions color = "primary" class="save-custom">
        SAVE
    </button>
    <button mat-raised-button actions color = "primary" class="reset-custom" mat-dialog-close>
        CANCEL
    </button>
  </app-centre-small-opener>

  
